var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.32 14.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HitDiscovery"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.27V1.91s0,0,0,0A2.17,2.17,0,0,1,2.24,0h10a1.41,1.41,0,0,1,1.49,1.5V3.26h.13a1.4,1.4,0,0,1,1.46,1.48v8a1.58,1.58,0,0,1-.05.43,1.4,1.4,0,0,1-1.43,1H2.11a2.18,2.18,0,0,1-2-1.58C.05,12.49,0,12.38,0,12.27ZM1,3.86V12a1.15,1.15,0,0,0,.74,1.13,1.45,1.45,0,0,0,.58.1h11.6a.45.45,0,0,0,.48-.49V11.21a.72.72,0,0,0,0-.13h-.19c-1.19,0-2.38,0-3.56,0A2.21,2.21,0,0,1,8.5,8.93a2.24,2.24,0,0,1,2.24-2.32h3.62V4.79c0-.42-.15-.57-.56-.57H2.26a2.3,2.3,0,0,1-1-.22Zm11.81-.6V1.51c0-.38-.16-.55-.55-.55h-10A1.61,1.61,0,0,0,1.82,1a1.11,1.11,0,0,0-.49,1.89,1.18,1.18,0,0,0,.89.35H12.77Zm1.59,4.32h-.12c-1.16,0-2.33,0-3.49,0a1.28,1.28,0,1,0,0,2.55h3.47l.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.61,8.85a.7.7,0,1,1-.69-.7A.69.69,0,0,1,11.61,8.85Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.bc62b5f6f4e0bda7cd59268d5a9d9009.svg";
export { ForwardRef as ReactComponent };